import React from "react";

const Marketing = () => {
  return (
    <div className="welcome-page-2">
      <div className="faq-page-wrapper">
        <header>
          <h1>HOW TO: Qualitätssicherung</h1>
        </header>
        <p>
          Damit sowohl EDEKA StartHub als auch alle Regionen und die EDEKA
          Zentrale sicherstellen können, dass alle Produkte, die den
          Einzelhändlern/Einzelhändlerinnen angeboten werden, verkehrsfähig
          sind, benötigen wir ein{" "}
          <strong>
            Zertifikat oder einen Laborbefund (sensorische Untersuchung
          </strong>
          und oftmals{" "}
          <strong>
            chemisch – physikalische Untersuchungsparameter) zur
            Verkehrsfähigkeit{" "}
          </strong>
          sowie eine <strong>Deklarationsüberprüfung </strong> Eurer Produkte.
          <br />
          Wichtig: Laborberichte bitte erst nach erfolgreicher Einkaufsprüfung
          und unserer Anfrage anfordern!
        </p>
        <ul className="qs-ul">
          <li>Gilt für jede Produktsorte.</li>
          <li> Deklarationsüberprüfung</li>
          <li>
            Laborbefund (mikrobiologische Untersuchung, sensorische Untersuchung
            und oftmals chemisch-physikalische Untersuchungsparameter)
          </li>
          <li>Bio-Zertifizierungen (wenn Bio-Produkt)</li>
          <li>Spezifikationen</li>
        </ul>

        <p>
          Solltet ihr diese Befunde{" "}
          <em>
            <strong>
              <u>NICHT</u>{" "}
            </strong>
          </em>
          haben, besteht die Möglichkeit eine Verkehrsfähigkeitsbescheinigung
          einzureichen, sodass die Verkehrsfähigkeit eurer Produkte vom
          Hersteller/Abfüller bestätigt wird. In diesem Fall muss der
          Hersteller/Abfüller IFS-, BRC- oder FSSC 22000- zertifiziert sein.
        </p>
        <p>Hierzu muss folgendes beachtet werden:</p>
        <p>
          - IFS, BRC oder FSSC 22000 Zertifikat vom Produzenten/Abfüller und
          eine Verkehrsfähigkeitsbescheinigung* (s.u.)
        </p>
        <p>
          Falls ihr weder Laborbefunde noch einen Zertifizierten
          Hersteller/Abfüller habt, empfehlen wir euch eure Produkte durch ein
          unabhängiges akkreditiertes Institut prüfen lassen. Dies ist absolut
          notwendig um das EDEKA StartHub-Programm zu durchlaufen und
          veröffentlicht zu werden.
        </p>
        <p>
          Wir haben bei dem Labor Bilacon GmbH EDEKA Konditionen vereinbart,
          sodass ihr dort diese Befunde für verbesserte Konditionen erhalten
          könnt.(12% Rabatt)
        </p>
        <p>
          Genauere Informationen hierzu könnt Ihr im{" "}
          <strong>
            &ldquo;EDEKA StartHub Guide - Fit für das Regal&rdquo;{" "}
          </strong>{" "}
          auf eurer Welcomepage nachlesen.
        </p>
        <p>
          <em>
            * Verkehrsfähigkeitsbescheinigung vom Hersteller
            <br />
            wir benötigen ein Dokument, welches nachweist, dass der Hersteller
            (IFS,BRC, FSSC 22000 zertifiziert ist) für euch produziert und der
            Hersteller somit die Verkehrsfähigkeit bestätigt.
            <br />
            Das heißt, dass die Deklaration und Laborbefunde nach den
            Verordnungen korrekt sind und die Produkte von euch uneingeschränkt
            verkehrsfähig sind. Das Dokument muss Folgendes beinhalten:
          </em>
        </p>
        <p>
          <em>
            Bescheinigung der Verkehrsfähigkeit durch Hersteller/Abfüller
            &ldquo;Produzent XY&rdquo; (im Besitz des IFS-Zertifikats) für
            Unternehmen XY.
          </em>
        </p>
        <br />
        <blockquote>
          Sehr geehrte Damen und Herren,
          <br />
          <br />
          hiermit bestätigen wir als Produzent/Abfüller des Produktes XY von
          Unternehmen XY dessen Verkehrsfähigkeit für den deutschen Markt. Wir
          bestätigen die Richtigkeit der Deklaration ebenso wie für die korrekte
          Zusammensetzung der Produkte (mit Produktbezeichnung).
          <br />
          <br />
          Wir sind als Hersteller IFS-Zertifiziert (siehe Anlage).
        </blockquote>
        <p>
          <em>
            Es sollten im Briefkopf die Adresse Unternehmen XY und der vom
            Produzent/Abfüller versehen sein. <br />
            Bitte als PDF und mit Unterschrift bzw. Stempel oder wenn
            elektronisch ausgehändigt mit dem Verweis &ldquo;dieses Dokument
            wurde elektronisch erstellt und ist somit ohne Unterschrift
            gültig&rdquo;.
          </em>
        </p>
      </div>
    </div>
  );
};

export default Marketing;
